export default __webpack_public_path__ + "static/thirdSecImg-12c84b9a2c74b9f4328f4949e140c980.png";